import { render, staticRenderFns } from "./NewsCategory.vue?vue&type=template&id=f9ae2af6&scoped=true&"
import script from "./NewsCategory.vue?vue&type=script&lang=js&"
export * from "./NewsCategory.vue?vue&type=script&lang=js&"
import style0 from "./NewsCategory.vue?vue&type=style&index=0&id=f9ae2af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ae2af6",
  null
  
)

export default component.exports